<div class="row m-0" *ngIf="showReqName">
    <div class="col-sm-12 p-0">
        <div class="req-name-button-wrap">
            <div class="requester-name-wrap">
                <span class="requester-short-name">{{requesterShortName}}</span>
                <span class="requester-full-name">{{requesterFullName}}</span>
            </div>
            <ng-content *ngIf="showUpdateBtn"></ng-content>
        </div>
    </div>
</div>

<div class="row m-0" *ngIf="cardDetails && !(!cardDetails[0].label && !cardDetails[0].value)">
    <div class="col-sm-12 p-0">
        <h6 class="info-title">{{cardTitle}}</h6>
    </div>
    <div class="col-sm-4 p-0" *ngFor="let cardDetail of cardDetails;let i=index;trackBy:trackByFn">
        <div class="info-details">
            <label class="info-lable" *ngIf="cardDetail.label">{{cardDetail.label}}</label>
            <span *ngIf="cardDetail.label">
                <p class="info-value" title="{{cardDetail.value}}"
                    *ngIf="!cardDetail.label.toLowerCase().includes('date') && cardDetail.value">
                    {{cardDetail.value}}</p>
                <p class="info-value" title="{{cardDetail.value}}"
                    *ngIf="!cardDetail.label.toLowerCase().includes('date') && !cardDetail.value">
                    - </p>
                <p class="info-value" title="{{cardDetail.value}}"
                    *ngIf="cardDetail.label.toLowerCase().includes('date') && cardDetail.value">
                    {{cardDetail.value | date: 'MM/dd/yyyy'}}</p>
                <p class="info-value" title="{{cardDetail.value}}"
                    *ngIf="cardDetail.label.toLowerCase().includes('date') && !cardDetail.value">
                    - </p>
            </span>
            <span *ngIf="!cardDetail.label">
                <a title="{{cardDetail.value}}"
                    *ngIf="!cardDetail.label.toLowerCase().includes('date') && cardDetail.value"
                    (click)="downloadFile(cardDetail.value)" class="hoverPointer">
                    {{cardDetail.value}}</a>
                <p class="info-value" title="{{cardDetail.value}}"
                    *ngIf="!cardDetail.label.toLowerCase().includes('date') && !cardDetail.value">
                    - </p>
            </span>
        </div>
    </div>
</div>